import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {AREA_OPTIONS, Provinces} from '@app/constants/Provinces';
import * as CandidateService from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import {cloneDeep} from 'lodash';
import ReactChipInput from "react-chip-input";
import {
    arrayIncludeItem, arrayToString, capitalizeName,
    checkEmailToSendInOtherEmails,
    monthOptions,
    stringToArray, stringToLowerCase, twoArrayHaveNotSameElement,
    twoArrayHaveSameElement,
    yearOptions
} from '@app/utils/CommonUtils';
import {Document, Page, pdfjs} from 'react-pdf';
import {
    CANDIDATE_CATEGORY_FIELDS, CANDIDATE_INPUT_INFO_TYPES, CANDIDATE_ORIGIN_APPROVE_STATUS_OPTIONS,
    CANDIDATE_ORIGINS_OPTIONS, CONTACT_NEED_APPROVE_FIELDS,
    CONTACT_NO_NEED_APPROVE_FIELDS,
    EMAIL_FILED_NAME,
    ENGAGEMENT_STATUS,
    FATE_TYPES, GENDERS,
    INDUSTRY_FUNCTIONS,
    JOB_SEND_REQUESTS,
    LATEST_STABLE_LEVELS, LOCAL_STORAGE_ALL_CANDIDATE_IDS,
    LOCAL_STORAGE_USER_LOGIN_INFO, ME_LIST_INPUT,
    OBJECT_SPECIALS, PersonTypeOptions,
    PHONE_FILED_NAME,
    RELATION_TYPES,
    ResponseCode,
    SUPPORT_LEVEL,
    SUPPORT_READY_LEVEL,
    SUPPORT_TITLE
} from '@app/constants/Common';
import {Link, useHistory} from 'react-router-dom';
import * as ExtractService from '@app/services/ExtractService';
import * as ValidateUtils from '@app/utils/ValidationUtils';
import ProcessExtractResultModal from '@pages/candidate/userinput/ProcessExtractResultModal';
import CandidateProcessNotes from "@pages/candidate/detail/CandidateProcessNotes";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";
import {searchAllInputInfo} from "@app/services/CandidateService";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import {checkExistsCommonFieldValues} from "@app/utils/CandidateUtils";
import * as CandidateUtils from "@app/utils/CandidateUtils";
import {requestDownloadCV} from "@app/services/ExtractService";
import ShowHideCandidatesModal from "@pages/candidate/commonview/ShowHideCandidatesModal";
import PriorityInputList from "@pages/candidate/userinput/PriorityInputList";
import {COUNTRIES, CANDIDATE_NATIONALITIES, checkNationalOptionsHaveExpatAndVN} from "@app/constants/Nationality";
import CandidateLanguageComponent from "@pages/candidate/commonview/language/CandidateLanguageComponent";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import JobSendRequestHistoryModal from "@pages/candidate/detail/JobSendRequestHistoryModal";
import JobSendRequestNotes from "@pages/candidate/detail/JobSendRequestNotes";
import RunJobMainModal from "@pages/job/runjob/RunJobMainModal";
import CareerSummaries from "@pages/candidate/detail/CareerSummaries";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import CandidateGeneral from "@pages/candidate/detail/CandidateGeneral";
import CandidateJobSeeking from '@pages/candidate/detail/CandidateJobSeeking';
import CandidateMaxUpdateDateModal from '@pages/candidate/detail/CandidateMaxUpdateDateModal';
import CandidateCVFiles from "@pages/candidate/detail/CandidateCVFiles";
import CandidateCVInfo from "@pages/candidate/detail/CandidateCVInfo";
import CandidateDVTJCUV from "@pages/candidate/detail/CandidateDVTJCUV";
import CandidateCustomNotes from "@pages/candidate/detail/CandidateCustomNotes";
import CandidateContactPoint from "@pages/candidate/detail/CandidateContactPoint";
import CandidateCategories, {CandidateCategoriesMode} from "@pages/candidate/userinput/component/CandidateCategories";
import CandidateLocation, {CandidateLocationMode} from "@pages/candidate/detail/CandidateLocation";
import QuickShotCard from "@pages/candidate/detail/QuickShotCard";
import HideUsersCard from "@pages/candidate/detail/HideUsersCard";
import ContactsImportantCard from "@pages/candidate/detail/ContactsImportantCard";
import ContactsOtherCard from "@pages/candidate/detail/ContactsOtherCard";
import ReferChecksCard from "@pages/candidate/detail/ReferChecksCard";
import PersonalRelationsCard from "@pages/candidate/detail/PersonalRelationsCard";
import CandidateOriginCard from "@pages/candidate/detail/CandidateOriginCard";
import GenderCard from "@pages/candidate/detail/GenderCard";
import CtvInfoCard from "@pages/candidate/detail/CtvInfoCard";
import NotesReferSupportCard from "@pages/candidate/detail/NotesReferSupportCard";
import CategoriesCard from "@pages/candidate/detail/CategoriesCard";
import FlowsCard from "@pages/candidate/detail/FlowsCard";
import CandidatePersonalInfo from './CandidatePersonalInfo';

const CandidateDetail = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [notes, setNotes] = useState({});
    const [curriculumVitae, setCurriculumVitae] = useState({});
    const [quickShots, setQuickShots] = useState({});
    const [contacts, setContacts] = useState({});
    const [dbContacts, setDbContacts] = useState({});
    // const [personal, setPersonal] = useState({});
    const [referChecks, setReferChecks] = useState([]);

    const [categories, setCategories] = useState({});
    const [flows, setFlows] = useState({});
    const [hideUsers, setHideUsers] = useState([]);

    const [relations, setRelations] = useState([]);
    const [infoAsCtv, setInfoAsCtv] = useState({is_ctv: "", ctv_type: ""});

    const [candidateOrigin, setCandidateOrigin] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [isEditNoteReferSupport, setIsEditNoteReferSupport] = useState(false);
    const [isEditQuickShots, setIsEditQuickShots] = useState(false);

    const [isEditContacts, setIsEditContacts] = useState(false);
    const [isEditOtherContacts, setIsEditOtherContacts] = useState(false);
    const [isEditPersonal, setIsEditPersonal] = useState(false);
    const [isEditReferChecks, setIsEditReferChecks] = useState(false);
    const [isEditGender, setIsEditGender] = useState(false);
    const [isEditCategories, setIsEditCategories] = useState(false);
    const [isEditFlows, setIsEditFlows] = useState(false);
    const [isEditRelations, setIsEditRelations] = useState(false);
    const [isEditInfoAsCtv, setIsEditInfoCtv] = useState(false);
    const [isEditCandidateOrigin, setIsEditCandidateOrigin] = useState(false);
    const [currentTab, setCurrentTab] = useState('quickshot-tab');
    const [processRefCheckResult, setProcessRefCheckResult] = useState([]);
    const [allInputInfo, setAllInputInfo] = useState({});
    const [hasPermission, setHasPermission] = useState(false);
    const [checkingPermission, setCheckingPermission] = useState(true);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentCandidateIndex, setCurrentCandidateIndex] = useState(0);
    const [showShowHideCandidatesModal, setShowShowHideCandidatesModal] = useState(false);
    const [showJobSendRequestHistory, setShowJobSendRequestHistory] = useState(false);
    const [showRunJobModal, setShowRunJobModal] = useState(false);
    const [showMaxUpdateDateModal, setShowMaxUpdateDateModal] = useState(false);
    const [candidateIsBlock, setCandidateIsBlock] = useState(false);

    const {candidateId} = props.match.params

    const history = useHistory();

    useEffect(() => {
        const strAllCanIds = localStorage.getItem(LOCAL_STORAGE_ALL_CANDIDATE_IDS)
        if (strAllCanIds) {
            const allCanIds = stringToArray(strAllCanIds)
            setAllCandidateIds(allCanIds)
            for (let i = 0; i < allCanIds.length; i++) {
                if (candidateId === allCanIds[i]) {
                    setCurrentCandidateIndex(i)
                    break
                }
            }
            localStorage.setItem(LOCAL_STORAGE_ALL_CANDIDATE_IDS, "")
        }
    }, [])

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    const checkPermissionShowCandidate = async (canId) => {
        setCheckingPermission(true)
        const res = await CandidateService.checkPermissionShowCandidate(canId)
        setHasPermission(res.sts_code !== ResponseCode.CAN_NOT_VIEW_CANDIDATE)
        setCheckingPermission(false)

        return res.sts_code !== ResponseCode.CAN_NOT_VIEW_CANDIDATE
    };

    const fetchReferChecks = (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateReferChecksDetail(canId).then((res) => {
            setReferChecks(res.content)
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const fetchCategories = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateCategoryDetail(canId).then((res) => {
            setCategories(res.content)
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        allInputInfo.allCandidateCategoriesInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.CandidateCategory)
        setAllInputInfo(cloneDeep(allInputInfo))
    };

    const fetchFlows = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateFlowDetail(canId).then((res) => {
            setFlows(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        allInputInfo.allFlowCategoriesInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.FlowCategory)
        const isblock = allInputInfo.allFlowCategoriesInfo?.find(item => item.block_state === 2);
        setCandidateIsBlock(!!isblock)
        setAllInputInfo(cloneDeep(allInputInfo))
    };

    const fetchHideCandidateUsers = async (canId) => {
        setIsLoading(true)
        CandidateService.getHideCandidateUsers(canId).then((res) => {
            setHideUsers(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const fetchCandidateNotes = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateNotesDetail(canId).then((res) => {
            setNotes(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        allInputInfo.allCandidateNotesInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.CandidateNotes)
        setAllInputInfo(cloneDeep(allInputInfo))
    };

    // const fetchCandidateProcessNotes = (canId) => {
    //     setIsLoading(true)
    //     CandidateService.getCandidateProcessNotes(canId).then((res) => {
    //         setProcessNotes(res.content)
    //     }).catch((error) => {
    //         toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
    //     }).finally(() => {
    //         setIsLoading(false)
    //     });
    // };

    const fetchQuickShots = async (canId) => {
        setIsLoading(true)
        CandidateService.getQuickShotDetail(canId).then((res) => {
            setQuickShots(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        allInputInfo.allCandidateNotesInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.CandidateNotes)
        setAllInputInfo(cloneDeep(allInputInfo))
    };

    const fetchCandidateContacts = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateContactDetail(canId).then((res) => {
            setContacts(res.content)
            setDbContacts(cloneDeep(res.content))
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        allInputInfo.allContactsInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.Contacts)
        setAllInputInfo(cloneDeep(allInputInfo))
    };

    const fetchCandidateRelations = (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateRelationsDetail(canId).then((res) => {
            setRelations(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const fetchCandidateOrigin = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidateOrigin(canId).then((res) => {
            setCandidateOrigin({...res.content})
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        allInputInfo.allOriginInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.Origin)
        setAllInputInfo(cloneDeep(allInputInfo))
    };

    

    // const updateCandidateGeneral = () => {
    //     setIsLoading(true)
    //     CandidateService.updateCandidateGeneralDetail({candidate_id: candidateId, general: general}).then((res) => {
    //         console.log(JSON.stringify(res))
    //         showSuccessMessageSaveData(res.sts_code)
    //         setIsEditPersonal(false)
    //     }).catch((error) => {
    //         toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
    //     }).finally(() => {
    //         setIsLoading(false)
    //     });
    // };

    

    const updateQuickShots = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        const notesInfo = allInputInfo.allCandidateNotesInfo
        if (notesInfo && notesInfo.length > 0) {
            quickShots.allCandidateNotesInfo = []
            notesInfo.forEach(item => {
                quickShots.allCandidateNotesInfo.push({
                    general_note: item.general_note,
                    important_note: item.important_note,
                    created_user: item.created_user
                })
            })
        }

        if (checkExistsCommonFieldValues(quickShots, userLoginInfo.id)) {
            return;
        }
        setIsLoading(true)
        CandidateService.updateQuickShotDetail({candidate_id: candidateId, quick_shots: quickShots}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                showSuccessMessageSaveData(res.sts_code)
                setIsEditQuickShots(false)
            } else if (res.sts_code === ResponseCode.PHONE_EMAIL_USED_BY_OTHER_USER) {
                toast.error(`Số điện thoại hoặc email đã được sử dụng bởi Person khác.`);
                alert(`Số điện thoại hoặc email đã được sử dụng bởi Person khác.`);
            } else {
                toast.error(`Cập nhật thông tin thất bại`);
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const updateCandidateContacts = async (importantContact) => {
        let requestBody = {candidate_id: candidateId, contacts: {}, need_approve: false}
        let updateContactFields = CONTACT_NO_NEED_APPROVE_FIELDS
        if (importantContact) {
            const arrOtherEmail = [...stringToArray(contacts.db_rarely_email), ...stringToArray(contacts.db_ever_email),
                ...stringToArray(contacts.db_block_email)]

            if (twoArrayHaveSameElement(stringToArray(contacts.email_to_send), arrOtherEmail)) {
                alert(Messages.emailToSendInErrorBlockEmails);
                toast.error(Messages.emailToSendInErrorBlockEmails);
                return;
            }

            // Check standard personal emails. Nếu user xác nhận ok sẽ tiếp tục xử lý tiếp theo.
            const confirm = await CandidateUtils.processWithoutPersonalEmail(stringToArray(contacts.email))
            if (!confirm) {
                return;
            }

            // Check contact has remove
            let dbContactValues = {}
            let inputContactValues = {}
            let hasRemoveContacts = false
            CONTACT_NEED_APPROVE_FIELDS.forEach(item => {
                dbContactValues[item.key] = stringToArray(dbContacts[item.key])
                inputContactValues[item.key] = stringToArray(contacts[item.key])
                if (dbContactValues[item.key].length > 0) {
                    dbContactValues[item.key].forEach(dbValue => {
                        if (!inputContactValues[item.key].includes(dbValue)) {
                            hasRemoveContacts = true
                        }
                    })
                }
            })
            if (hasRemoveContacts && !userLoginInfo.is_superuser) {
                let senderNote = prompt("Bạn có thực hiện xoá thông tin contacts. " +
                    "Vui lòng nhập lý do (Bắt buộc):", "");
                if (senderNote === null || senderNote === "") {
                    if (senderNote === "") {
                        alert("Bạn không thể gửi yêu cầu cập nhật thông tin nếu không cung cấp lý do.")
                    }

                    return
                }
                requestBody.sender_note = senderNote
            }

            updateContactFields = CONTACT_NEED_APPROVE_FIELDS
            requestBody.need_approve = true
        }

        updateContactFields.forEach(item => {
            requestBody.contacts[item.key] = contacts[item.key]
        })

        setIsLoading(true)
        CandidateService.updateCandidateContactDetail(requestBody).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                showSuccessMessageSaveData(res.sts_code)
                if (importantContact) {
                    setIsEditContacts(false)
                } else {
                    setIsEditOtherContacts(false)
                }

                fetchCandidateContacts(candidateId)
            } else if (res.sts_code === ResponseCode.PHONE_EMAIL_USED_BY_OTHER_USER) {
                toast.error(res.message);
                alert(res.message);
            } else if (res.sts_code === ResponseCode.NEED_WAITING_APPROVE) {
                toast.info(Messages.infoWaitingApprove);
                alert(Messages.infoWaitingApprove);
                setIsEditContacts(false)
            } else {
                alertMessage(res.sts_code, false, true)
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const updateCandidateReferChecks = () => {
        setIsLoading(true)
        CandidateService.updateCandidateReferChecksDetail({candidate_id: candidateId, refer_checks: referChecks}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEditReferChecks(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const updateCandidateRelations = () => {
        CandidateService.updateCandidateRelationsDetail({candidate_id: candidateId, relations: relations}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                showSuccessMessageSaveData(res.sts_code)
                setIsEditRelations(false)
                setRelations(res.content)
            } else {
                toast.error(res.message);
                alert(res.message)
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const fetchCandidateData = (tabId, canId) => {
        if (!canId) {
            canId = candidateId
        }
        switch (tabId) {
            case 'quickshot-tab':
                fetchFlows(canId);
                fetchQuickShots(canId);
                break;
            case 'career-summary-tab':
                // fetchCandidateCareerSummary(canId);
                break;
            case 'flow-categories-tab':
                fetchFlows(canId);
                fetchCategories(canId);
                if (userLoginInfo && userLoginInfo.is_superuser) {
                    fetchHideCandidateUsers(canId)
                }
                break;
            case 'contacts-tab':
                fetchCandidateContacts(canId);
                break;
            case 'general-tab':
                // fetchCandidateGeneral(canId);
                fetchCandidateOrigin(canId);
                break;
            case 'personal-tab':
                // fetchPersonal(canId);
                // fetchLocations(canId);
                break;
            case 'curriculum-vitae-tab':
                fetchReferChecks(canId);
                break;
            case 'notes-tab':
                fetchCandidateNotes(canId);
                break;
            case 'relations-tab':
                fetchCandidateRelations(canId);
                break;
            case 'ctv-tab':
                // fetchInfoAsCtv(canId);
                break;
            case 'job-seeking-tab':
                // fetchJobSeeking(canId);
                break;
            case 'note-refer-support-tab':
                fetchCandidateNotes(canId);
                break;
            case 'process-note-tab':
                //fetchCandidateProcessNotes(canId);
                break;
            default:
                break;
        }
    }

    const onOpenNextCandidateDetail = (nextIndex) => {
        setCurrentCandidateIndex(nextIndex)
        history.push(`/candidate/detail/${allCandidateIds[nextIndex]}`,
            {allCandidateIds: allCandidateIds, currentCandidateIndex: nextIndex})
        fetchCandidateData(currentTab, allCandidateIds[nextIndex])
        // fetchCandidateCV(allCandidateIds[nextIndex])
    }

    useEffect(async () => {
        const hasPermissionShowCandidate = await checkPermissionShowCandidate(candidateId)
        if (!hasPermissionShowCandidate) {
            setHasPermission(false)
            alert(Messages.youCanNotShowThisCandidate)
            return;
        }

        setHasPermission(true)

        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            await setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

        fetchCandidateData(currentTab)
        if (currentTab === 'quickshot-tab') {
            // fetchCandidateCV(candidateId)
        }
    }, []);


    const onChangeNotes = (event, fieldName) => {
        if (fieldName === 'engagement_status' || fieldName === 'support_title' || fieldName === 'fate_type'
            || fieldName === 'support_level' || fieldName === 'support_ready_level') {
            notes[fieldName] = event
        } else {
            notes[event.target.name] = event.target.value
        }

        setNotes({...notes})
    }

    const onChangeQuickShotItem = (event, fieldName) => {
        if (fieldName === 'engagement_status' || fieldName === 'support_title') {
            quickShots[fieldName] = event
        } else if (PHONE_FILED_NAME.includes(fieldName)) {
            if (!event) {
                return;
            }
            // Validate
            if (event && !ValidateUtils.validatePhone(event, ';')) {
                alert('Số điện thoại nhập không hợp lệ!');
                return;
            }
            let arr = cloneDeep(quickShots[fieldName])
            if (!arr) {
                arr = []
            }
            if (!arrayIncludeItem(arr, event)) {
                arr.push(event)
                quickShots[fieldName] = arr
            } else {
                alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
            }
        } else {
            quickShots[event.target.name] = event.target.value
        }

        setQuickShots({...quickShots})
    }

    const onRemoveQuickShotItem = (index, fieldName) => {
        let arr = cloneDeep(quickShots[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            quickShots[fieldName] = arr
            setQuickShots({...quickShots})
        }

    }

    const checkEmailToSendInErrorBlockEmail = () => {
        const arrEmailToSend = stringToArray(contacts.email_to_send)
        if (arrEmailToSend) {
            let arrOtherEmail = [
                ...stringToArray(contacts.db_rarely_email),
                ...stringToArray(contacts.db_ever_email),
                ...stringToArray(contacts.db_block_email)
            ]
            if (twoArrayHaveSameElement(stringToArray(arrEmailToSend), arrOtherEmail)) {
                return <span className={'text-danger w-100 mb-2'}>
                    {Messages.emailToSendInErrorBlockEmails}
            </span>
            }
        }
        return ""

    }

    const haveEmailToSendAdNotInAllEmailToSends = (emailToSendAd, allContactInfos) => {
        if (!allContactInfos || !emailToSendAd) {
            return false
        }
        const arrEmailToSendAds = stringToArray(emailToSendAd)
        let arrEmailToSends = stringToArray(contacts.email_to_send)
        allContactInfos.forEach(item => {
            arrEmailToSends = [...arrEmailToSends, ...stringToArray(item.email_to_send)]
        })

        return twoArrayHaveNotSameElement(arrEmailToSendAds, arrEmailToSends);

    }

    const checkEmailToSendInAllEmail = () => {
        const arrEmailToSend = stringToArray(contacts.email_to_send)
        if (arrEmailToSend && arrEmailToSend.length > 0) {
            let arrOtherEmail = [
                ...stringToArray(contacts.db_rarely_email),
                ...stringToArray(contacts.db_ever_email),
                ...stringToArray(contacts.db_block_email),
                ...stringToArray(contacts.db_email),
                ...stringToArray(contacts.db_email_to_send)]
            if (!checkEmailToSendInOtherEmails(arrEmailToSend, arrOtherEmail)) {
                return <span className={'text-danger w-100 mb-2'}>
                    {Messages.emailToSendNotInAllEmails}
            </span>
            }
        }

        return ""
    }

    const onAddContactItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(contacts[fieldName])
        if (!arr) {
            arr = []
        }

        // Validate
        if (PHONE_FILED_NAME.includes(fieldName)) {
            value = value.replaceAll(" ", "")
            if (value && !ValidateUtils.validatePhone(value)) {
                alert('Số điện thoại nhập không hợp lệ!');
                return;
            }
        } else if (EMAIL_FILED_NAME.includes(fieldName)) {
            value = value.replaceAll(" ", "")
            if (value && !ValidateUtils.validateEmail(value)) {
                alert('Email nhập không hợp lệ!');
                return;
            }
        } else if (['email_to_send', 'email_to_send_ad'].includes(fieldName)) {
            if (haveEmailToSendAdNotInAllEmailToSends(value, allInputInfo.allContactsInfo)) {
                showMessage(Messages.haveEmailToSendAdNotInEmailToSendAllUser)
                return;
            }
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            contacts[fieldName] = arr
            if (fieldName === 'email_to_send') {
                checkEmailToSendInErrorBlockEmail()
                checkEmailToSendInAllEmail()
            }

            setContacts({...contacts})
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }


    const onRemoveContactItem = (index, fieldName) => {
        let arr = cloneDeep(contacts[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            contacts[fieldName] = arr
            if (fieldName === 'email_to_send') {
                checkEmailToSendInErrorBlockEmail()
                checkEmailToSendInAllEmail()
            }
            setContacts({...contacts})
        }
    }

    const onAddCategoryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(categories[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            categories[fieldName] = arr
            setCategories({...categories})
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveCategoryItem = (index, fieldName) => {
        let arr = cloneDeep(categories[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            categories[fieldName] = arr
            setCategories({...categories})
        }
    }

    const onChangeCategoryItem = (event, fieldName) => {
        if (fieldName === 'industry_function') {
            categories[fieldName] = event
        } else {
            categories[event.target.name] = event.target.value
        }
        setCategories({...categories})
    }

    const onChangeFlows = (event, fieldName) => {
        if (fieldName === 'object_special' || fieldName === 'job_send_request') {
            flows[fieldName] = event;
        } else {
            flows[event.target.name] = event.target.value
        }

        setFlows({...flows})
    }

    // const onChangePersonalCallback = (perInfo) => {
    //     setPersonal({...perInfo})
    // }

    const onChangeNoteAsCtv = (event) => {
        infoAsCtv[event.target.name] = event.target.value
        setInfoAsCtv({...infoAsCtv})
    }

    const inputDisableView = (values, index) => {
        return <input type='text' className='form-control' disabled={'disabled'}
                      style={{
                          position: 'absolute',
                          width: '100%',
                          top: 32,
                          height: '80%',
                          backgroundColor: 'rgba(233, 236, 239,0.4)'
                      }} />;
    }

    const onAddReferContents = (event) => {
        console.log('onAddReferCheck');
        let refChecks = cloneDeep(referChecks)
        if (!refChecks) {
            refChecks = [];
        }

        if (refChecks.length > 0 && !refChecks[refChecks.length-1]) {
            return;
        }
        refChecks.push(
            {
                candidate_cv_id: curriculumVitae.id,
                content: ''
            }
        );
        setReferChecks(refChecks);
    };

    const onDeleteReferContents = (index) => {
        console.log('onDeleteReferContents');
        let refChecks = cloneDeep(referChecks)
        if (refChecks.length === 1) {
            refChecks = [];
        } else {
            refChecks.splice(index, 1);
        }
        setReferChecks(refChecks);
    };

    const onProcessReferCheck = (index) => {
        console.log('onProcessReferCheck');
        ExtractService.processReferCheck({candidate_id: candidateId, refer_check: referChecks[index]}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Xử lý nội dung refer check thành công.`);
                setProcessRefCheckResult([res.content])
                referChecks[index] = res.content.refer_check
                setReferChecks(referChecks)
                curriculumVitae.pm_input_state=1
                curriculumVitae.has_prefer_check=true
            } else {
                toast.error(res.message);
                alert(res.message)
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const onChangeReferContentInput = (event, index) => {
        console.log('onChangeReferContentInput');
        referChecks[index].content = event.target.value;
        setReferChecks(cloneDeep(referChecks));
    };


    const onAddRelationContents = (event) => {
        console.log('onAddRelationContents');
        let canRelations = cloneDeep(relations)
        if (!canRelations) {
            canRelations = [];
        }

        let latestRow = canRelations[canRelations.length - 1]
        if (canRelations.length > 0 && !latestRow.personal_id
            && !latestRow.full_name
            && !latestRow.displayed_company
            && !latestRow.displayed_title
            && !latestRow.relation_level
            && !latestRow.note
            && !latestRow.relation_type) {
            return;
        }
        canRelations.push({
            personal_links: '',
            relation_type: '',
            created_user: userLoginInfo.id
        });
        setRelations(canRelations);
    };

    const onDeleteRelationContents = (index) => {
        console.log('onDeleteRelationContents');
        let canRelations = cloneDeep(relations)
        if (canRelations.length === 1) {
            canRelations = [];
        } else {
            canRelations.splice(index, 1);
        }
        setRelations(canRelations);
    };

    const onChangeRelationContentInput = (event, index, fieldName) => {
        console.log('onChangeRelationContentInput');
        if (fieldName === 'relation_type') {
            relations[index][fieldName] = event
        } else {
            relations[index][fieldName] = event.target.value;
        }
        setRelations([...relations]);
    };

    const onTabClicked = (tabId) => {
        if (tabId !== currentTab) {
            fetchCandidateData(tabId)
        }

        setCurrentTab(tabId);
    };

    const onShowShowHideCandidatesModal = (isAllCanIds = false) => {
        setShowShowHideCandidatesModal(true)
    }

    const openRunJobModal = () => {
        setShowRunJobModal(true)
    }

    return (
        <>
            {hasPermission && !checkingPermission &&
                <div>
                    <div className={'row'}>
                        <div className={'col-sm-6'}>
                            <CandidateCVFiles candidateId={candidateId}
                                              currCV={curriculumVitae}
                                              onSelectCurrentCV={cv => setCurriculumVitae(cv)}/>
                        </div>
                        <div className={'col-sm-6'}>
                            <ul className='nav nav-tabs' role='tablist'>
                                <li className='nav-item'>
                                    <a className='nav-link active' data-toggle='tab' href='#quickshot-tab'
                                       onClick={() => onTabClicked('quickshot-tab')}>Quick shot</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#career-summary-tab'
                                       onClick={() => onTabClicked('career-summary-tab')}>Career Summary</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#flow-categories-tab'
                                       onClick={() => onTabClicked('flow-categories-tab')}>Phân loại & phân luồng</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#contacts-tab'
                                       onClick={() => onTabClicked('contacts-tab')}>Contacts</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#curriculum-vitae-tab'
                                       onClick={() => onTabClicked('curriculum-vitae-tab')}>CV</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#relations-tab'
                                       onClick={() => onTabClicked('relations-tab')}>Relations</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#general-tab'
                                       onClick={() => onTabClicked('general-tab')}>General</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#personal-tab'
                                       onClick={() => onTabClicked('personal-tab')}>Personal</a>
                                </li>
                                {userLoginInfo.is_superuser &&
                                    <li className='nav-item'>
                                        <a className='nav-link' data-toggle='tab' href='#ctv-tab'
                                           onClick={() => onTabClicked('ctv-tab')}>CTV</a>
                                    </li>
                                }
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#job-seeking-tab'
                                       onClick={() => onTabClicked('job-seeking-tab')}>Job Seeking</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#note-refer-support-tab'
                                       onClick={() => onTabClicked('note-refer-support-tab')}>Note for NHỜ REFER, HỖ
                                        TRỢ</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#process-note-tab'
                                       onClick={() => onTabClicked('process-note-tab')}>Process Notes</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#language-tab'
                                       onClick={() => onTabClicked('language-tab')}>Languages</a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' data-toggle='tab' href='#custom-notes-tab'
                                       onClick={() => onTabClicked('custom-notes-tab')}>Notes</a>
                                </li>
                                {userLoginInfo.is_superuser &&
                                    <li className='nav-item'>
                                        <a className='nav-link' data-toggle='tab' href='#dvtjcuv-tab'
                                           onClick={() => onTabClicked('dvtjcuv-tab')}>DVTJCUV</a>
                                    </li>
                                }
                                {userLoginInfo.is_superuser &&
                                    <li className='nav-item'>
                                        <a className='nav-link' data-toggle='tab' href='#contact-point-tab'
                                           onClick={() => onTabClicked('contact-point-tab')}>INFO as a CONTACT POINT/HIRING MGR</a>
                                    </li>
                                }
                                {userLoginInfo.is_superuser &&
                                    <>
                                    <li className='nav-item'>
                                        <a className='nav-link' data-toggle='tab' href='#mj-candidate-category-tab'
                                           onClick={() => onTabClicked('mj-candidate-category-tab')}>To match job</a>
                                    </li>
                                    <li className='nav-item'>
                                        <a className='nav-link' data-toggle='tab' href='#rc-candidate-category-tab'
                                           onClick={() => onTabClicked('rc-candidate-category-tab')}>To receive Cdd</a>
                                    </li>
                                    </>
                                }
                            </ul>
                            <div className='tab-content'>
                                <div id='quickshot-tab' className='tab-pane active'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    <QuickShotCard
                                        isEditQuickShots={isEditQuickShots}
                                        setIsEditQuickShots={setIsEditQuickShots}
                                        updateQuickShots={updateQuickShots}
                                        quickShots={quickShots}
                                        onChangeQuickShotItem={onChangeQuickShotItem}
                                        ENGAGEMENT_STATUS={ENGAGEMENT_STATUS}
                                        SUPPORT_TITLE={SUPPORT_TITLE}
                                        allInputInfo={allInputInfo}
                                    />
                                </div>
                                <div id='career-summary-tab' className='tab-pane fade'>
                                    {currentTab === 'career-summary-tab' &&
                                        <CareerSummaries candidateId={candidateId}/>
                                    }
                                </div>
                                <div id='flow-categories-tab' className='tab-pane fade'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    <CategoriesCard
                                        initialCategories={categories}
                                        candidateId={candidateId}
                                        allInputInfo={allInputInfo}
                                    />
                                    <FlowsCard
                                        initialFlows={flows}
                                        allInputInfo={allInputInfo}
                                        candidateId={candidateId}
                                        setIsEditFlows={setIsEditFlows}
                                        onOpenHistory={() => setShowJobSendRequestHistory(true)}
                                    />

                                    <JobSendRequestNotes candidateId={candidateId}/>

                                    {userLoginInfo && userLoginInfo.is_superuser &&
                                        <HideUsersCard hideUsers={hideUsers} />
                                    }
                                </div>
                                <div id='contacts-tab' className='tab-pane fade'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    <ContactsImportantCard
                                        isEditContacts={isEditContacts}
                                        setIsEditContacts={setIsEditContacts}
                                        updateCandidateContacts={updateCandidateContacts}
                                        contacts={contacts}
                                        userLoginInfo={userLoginInfo}
                                        checkEmailToSendInErrorBlockEmail={checkEmailToSendInErrorBlockEmail}
                                        haveEmailToSendAdNotInAllEmailToSends={haveEmailToSendAdNotInAllEmailToSends}
                                        checkEmailToSendInAllEmail={checkEmailToSendInAllEmail}
                                        onAddContactItem={onAddContactItem}
                                        onRemoveContactItem={onRemoveContactItem}
                                        inputDisableView={inputDisableView}
                                        allInputInfo={allInputInfo}
                                    />
                                    <ContactsOtherCard
                                        isEditOtherContacts={isEditOtherContacts}
                                        setIsEditOtherContacts={setIsEditOtherContacts}
                                        updateCandidateContacts={updateCandidateContacts}
                                        contacts={contacts}
                                        onAddContactItem={onAddContactItem}
                                        onRemoveContactItem={onRemoveContactItem}
                                        inputDisableView={inputDisableView}
                                        allInputInfo={allInputInfo}
                                    />
                                </div>
                                <div id='curriculum-vitae-tab' className='tab-pane mt-3'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    <ReferChecksCard
                                        isEditReferChecks={isEditReferChecks}
                                        setIsEditReferChecks={setIsEditReferChecks}
                                        updateCandidateReferChecks={updateCandidateReferChecks}
                                        onAddReferContents={onAddReferContents}
                                        referChecks={referChecks}
                                        onChangeReferContentInput={onChangeReferContentInput}
                                        onProcessReferCheck={onProcessReferCheck}
                                        onDeleteReferContents={onDeleteReferContents}
                                    />
                                    <CandidateCVInfo
                                     cvInfo={curriculumVitae}
                                    //  onChange={cv => setCurriculumVitae(cloneDeep(cv))}
                                     />
                                </div>
                                <div id='relations-tab' className='tab-pane mt-3'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    <PersonalRelationsCard
                                        isEditRelations={isEditRelations}
                                        setIsEditRelations={setIsEditRelations}
                                        updateCandidateRelations={updateCandidateRelations}
                                        onAddRelationContents={onAddRelationContents}
                                        relations={relations}
                                        userLoginInfo={userLoginInfo}
                                        RELATION_TYPES={RELATION_TYPES}
                                        onChangeRelationContentInput={onChangeRelationContentInput}
                                        onDeleteRelationContents={onDeleteRelationContents}
                                    />
                                </div>
                                {currentTab === 'general-tab' &&
                                    <div id='general-tab' className='tab-pane'
                                         style={{height: '83vh', overflow: 'auto'}}>
                                        <CandidateGeneral candidateId={candidateId}/>
                                        <CandidateOriginCard
                                            candidateOrigin={candidateOrigin}
                                            allInputInfo={allInputInfo}
                                            candidateId={candidateId}
                                        />
                                        <PriorityInputList candidateId={candidateId}/>
                                    </div>
                                }
                                {currentTab === 'personal-tab' &&
                                <div id='personal-tab' className='tab-pane' style={{height: '83vh', overflow: 'auto'}}>
                                    <CandidatePersonalInfo
                                        candidateId={candidateId}
                                        allInputInfo={allInputInfo}
                                    />
                                    <GenderCard
                                        // isEditGender={isEditGender}
                                        // setIsEditGender={setIsEditGender}
                                        // updateCandidatePersonal={updateCandidatePersonal}
                                        // initPersonal={personal}
                                        // stringToLowerCase={stringToLowerCase}
                                        // userLoginInfo={userLoginInfo}
                                        candidateId={candidateId}
                                        // onChange={onChangePersonalCallback}
                                        allInputInfo={allInputInfo}
                                    />
                                    <CandidateLocation candidateId={candidateId}/>
                                </div>
                                }
                                <div id='ctv-tab' className='tab-pane' style={{height: '83vh', overflow: 'auto'}}>
                                    <CtvInfoCard
                                        candidateId={candidateId}
                                        initialInfoAsCtv={infoAsCtv}
                                        // onSave={(fields, values) => updateInfoAsCtv(fields, values)}
                                    />
                                </div>
                                <div id='job-seeking-tab' className='tab-pane fade'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    {currentTab === 'job-seeking-tab' &&
                                        <CandidateJobSeeking candidateId={candidateId}/>
                                    }
                                </div>
                                <div id='note-refer-support-tab' className='tab-pane'>
                                    <NotesReferSupportCard
                                        candidateId={candidateId}
                                        initialNotes={notes}
                                        allInputInfo={allInputInfo}
                                        // onSave={(newNotes) => updateCandidateNotes(newNotes)}
                                    />
                                </div>
                                <div id='process-note-tab' className='tab-pane'
                                     style={{height: '83vh', overflow: 'auto'}}>
                                    <div className='card card-default'>
                                        <div className='card-header'>
                                            <h3 className='card-title text-bold'>Notes</h3>
                                            <div className='card-tools'>
                                            </div>
                                        </div>
                                        <div className='card-body row'>
                                            <CandidateProcessNotes
                                                candidateId={candidateId}
                                            />
                                        </div>
                                    </div>

                                </div>
                                {currentTab === 'language-tab' &&
                                    <div id='language-tab' className='tab-pane'
                                         style={{height: '83vh', overflow: 'auto'}}>
                                        <CandidateLanguageComponent
                                         candidateId={candidateId}
                                         mode={CandidateDetailLanguageMode.DETAIL}/>
                                    </div>
                                }
                                {currentTab === 'custom-notes-tab' &&
                                    <div id='custom-notes-tab' className='tab-pane'
                                         style={{height: '83vh', overflow: 'auto'}}>
                                        <CandidateCustomNotes
                                            candidateId={candidateId}
                                            allInputInfo={allInputInfo}
                                        />
                                    </div>
                                }
                                {currentTab === 'dvtjcuv-tab' &&
                                    <div id='dvtjcuv-tab' className='tab-pane'
                                         style={{height: '83vh', overflow: 'auto'}}>
                                        <CandidateDVTJCUV candidateId={candidateId}/>
                                    </div>
                                }
                                {currentTab === 'contact-point-tab' &&
                                    <div id='contact-point-tab' className='tab-pane'
                                         style={{height: '83vh', overflow: 'auto'}}>
                                        <CandidateContactPoint candidateId={candidateId}/>
                                    </div>
                                }
                                {currentTab === 'mj-candidate-category-tab' &&
                                    <div id='mj-candidate-category-tab' className='tab-pane'
                                         style={{height: '83vh', overflow: 'auto'}}>
                                        <CandidateCategories
                                            isAllUsers
                                            candidateId={candidateId}
                                            categoryMode={CandidateCategoriesMode.MJ_CATEGORY}/>
                                    </div>
                                }
                                {currentTab === 'rc-candidate-category-tab' &&
                                    <>
                                        <div id='rc-candidate-category-tab' className='tab-pane'
                                             style={{height: '83vh', overflow: 'auto'}}>
                                            <CandidateCategories candidateId={candidateId}
                                                                 isAllUsers
                                                                 categoryMode={CandidateCategoriesMode.RC_CATEGORY}/>
                                            <CandidateLocation
                                                isAllUsers
                                                candidateId={candidateId} mode={CandidateLocationMode.RC}
                                            />
                                            <CandidateLanguageComponent
                                                candidateId={candidateId}
                                                isAllUsers
                                                mode={CandidateDetailLanguageMode.RC}/>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{position: "absolute", top: 10, right: "40%", zIndex: 3001}} className={"row"}>
                        {!showShowHideCandidatesModal && !showRunJobModal && !showJobSendRequestHistory &&
                            <>
                                <div className={'text-right mr-3'}>
                                    <button className='btn btn-block btn-outline-primary'
                                            disabled={currentCandidateIndex === 0 || isLoading}
                                            type={'button'}
                                            onClick={() => onOpenNextCandidateDetail(currentCandidateIndex - 1)}>
                                        <i className='fas fa-arrow-left'/> Back
                                    </button>
                                </div>
                                <div className={'text-right'}>
                                    <button className='btn btn-block btn-outline-primary'
                                            disabled={currentCandidateIndex >= allCandidateIds.length - 1 || isLoading}
                                            type={'button'}
                                            onClick={() => onOpenNextCandidateDetail(currentCandidateIndex + 1)}>
                                        <i className='fas fa-arrow-right'/> Next
                                    </button>
                                </div>
                                {userLoginInfo.is_superuser &&
                                    <div className={'text-right ml-3'}>
                                        <button type={"button"}
                                                onClick={() => onShowShowHideCandidatesModal()}
                                                className={'btn btn-danger'}>Show/Hide UV
                                        </button>
                                    </div>
                                }
                                <div className={'text-right ml-3'}>
                                    <button type={"button"}
                                            onClick={() => openRunJobModal()}
                                            className={'btn btn-primary'}>Process job
                                    </button>
                                </div>
                                <div className={'text-right ml-3'}>
                                    <button type={"button"}
                                            onClick={() => setShowMaxUpdateDateModal(true)}
                                            className={'btn btn-default'}>Update đến
                                    </button>
                                </div>
                                <div className={'text-right ml-3'}>
                                    <button type={"button"}
                                            onClick={() => setShowMaxUpdateDateModal(true)}
                                            className={'btn btn-default'}>Update đến
                                    </button>
                                </div>
                                {candidateIsBlock &&
                                <button type={"button"}
                                        className={'btn btn-warning ml-3'}> 
                                        <span className='text-danger text-bold' style={{fontSize: 20}}>
                                            BLOCKED
                                        </span>
                                </button>
                                }
                            </>
                        }
                    </div>
                    {processRefCheckResult.length > 0 &&
                        <ProcessExtractResultModal extractResults={processRefCheckResult}
                                                   isShow={processRefCheckResult.length > 0}
                                                   onClose={() => setProcessRefCheckResult([])}/>
                    }
                    <ShowHideCandidatesModal
                        isShow={showShowHideCandidatesModal}
                        candidateIds={[candidateId]}
                        onClose={(isSuccess) => {
                            setShowShowHideCandidatesModal(false)
                            if (isSuccess === true) {
                                toast.success(`Xử lý thành công.`);
                            } else if (isSuccess === false) {
                                toast.error(`Xử lý thất bại.`);
                            }
                        }}/>

                    <JobSendRequestHistoryModal
                        candidateId={candidateId}
                        isShow={showJobSendRequestHistory}
                        onClose={() => setShowJobSendRequestHistory(false)}/>
                    {showRunJobModal &&
                        <RunJobMainModal candidateIds={[candidateId]}
                                         onClose={() => setShowRunJobModal(false)}
                                         isShow={showRunJobModal}/>
                    }
                    {showMaxUpdateDateModal &&
                        <CandidateMaxUpdateDateModal candidateId={candidateId}
                                         onClose={() => setShowMaxUpdateDateModal(false)}
                                         isShow={showMaxUpdateDateModal}/>
                    }

                </div>
            }
        </>
    );
};

export default CandidateDetail;
